import { UnknownAction, ThunkDispatch, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import reducer from "./reducer";
import { pagesApi } from "./reducer/pages.api";
import { faviconsApi } from "./reducer/favicons.api";
import { navigationApi } from "./reducer/navigation.api";
import { mediaApi } from "./reducer/media.api";
import { customersApi } from "./reducer/customers.api";
import { fontsApi } from "./reducer/fonts.api";
import { directJobsApi } from "./reducer/directJobs.api";

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      pagesApi.middleware,
      faviconsApi.middleware,
      navigationApi.middleware,
      mediaApi.middleware,
      customersApi.middleware,
      fontsApi.middleware,
      directJobsApi.middleware,
    ]),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, any, UnknownAction>;

export default store;
